<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-row :gutter="12" style="margin-bottom: 16px">
        <a-col :span="6">
          <div class="form-item">
            <span class="form-label">{{ $t(I18N_KEY.CUSTCONVERTREAL + 'dataDt') }}:</span>
            <a-range-picker v-model="queryParam.dataDt" style="width: 100%" format="DD-MM-YYYY" />
          </div>
        </a-col>
        <a-col :span="8">
          <a-button type="primary" @click="searchQuery" icon="search">
            {{ $t(I18N_KEY.CUSTCONVERTREAL + 'query') }}
          </a-button>
          <!-- <a-button type="primary" @click="downLoadData" icon="download" style="margin-left: 8px">
            {{ $t('exportFile') }}
          </a-button> -->
        </a-col>
      </a-row>

      <a-table
        ref="table"
        size="middle"
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :scroll="{ x: 3800, y: 2000 }"
        :rowClassName="rowClassName"
        bordered
        @change="handleTableChange"
        @expand="extpand"
      >
        <template slot="dataDt" slot-scope="text">
          {{ text ? transformTime(text, 1) : '' }}
        </template>
        <a-table
          slot="expandedRowRender"
          slot-scope="text"
          ref="table"
          size="middle"
          :columns="innerColumns"
          :data-source="text.dataDetails"
          :loading="loading"
          :pagination="false"
          bordered
        >
        </a-table>
      </a-table>
    </div>
    <RefundTradeModal ref="modalForm" @ok="modalFormOk"></RefundTradeModal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getAppAllCount, getApplist, getConvertData } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import { REFUND_TRADE_STATUS } from '@/constants/status'
import RefundTradeModal from './modules/RefundTradeModal'
import moment from 'moment'
import exportFile from '@/webpublicapi/exportFile'
import { transformTime } from '@/components/_util/util'

const I18N_KEY = {
  CUSTCONVERTREAL: 'custConvertReal.',
}

export default {
  name: 'AppList',
  components: {
    RefundTradeModal,
    Dict,
  },
  data() {
    return {
      I18N_KEY,
      visible: false,
      REFUND_TRADE_STATUS,
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },

      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      innerData: [],
      appList: [],
      // Query conditions
      queryParam: {
        dataDt: [moment().add('days', -60), moment().add('days', 0)],
        appssidList: [],
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 },
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'dataDt'),
          align: 'left',
          dataIndex: 'dataDt',
          width: 100,
          scopedSlots: { customRender: 'dataDt' },
        },
        // {
        //   title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'appName'),
        //   align: 'left',
        //   dataIndex: 'appName',
        // },
        // {
        //   title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'appSsid'),
        //   align: 'left',
        //   dataIndex: 'appSsid',
        // },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'installs'),
          align: 'left',
          dataIndex: 'installs',
          width: 100,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'optCount'),
          align: 'left',
          dataIndex: 'optCount',
          width: 230,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regCount'),
          align: 'left',
          dataIndex: 'regCount',
          width: 100,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'basicCount'),
          align: 'left',
          dataIndex: 'basicCount',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'linkmanCount'),
          align: 'left',
          dataIndex: 'linkmanCount',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'jsonCount'),
          align: 'left',
          dataIndex: 'jsonCount',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idimageCount'),
          align: 'left',
          dataIndex: 'idimageCount',
          width: 240,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'faceCount'),
          align: 'left',
          dataIndex: 'faceCount',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idnoCount'),
          align: 'left',
          dataIndex: 'idnoCount',
          width: 240,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'bankcardCount'),
          align: 'left',
          dataIndex: 'bankcardCount',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyCount'),
          align: 'left',
          dataIndex: 'applyCount',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'accessCount'),
          align: 'left',
          dataIndex: 'accessCount',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'loanCount'),
          align: 'left',
          dataIndex: 'loanCount',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'installsOptRate'),
          align: 'left',
          dataIndex: 'installsOptRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'optRegRate'),
          align: 'left',
          dataIndex: 'optRegRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regBasicRate'),
          align: 'left',
          dataIndex: 'regBasicRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'workLinkmanRate'),
          align: 'left',
          dataIndex: 'workLinkmanRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'linkedManJsonRate'),
          align: 'left',
          dataIndex: 'linkedManJsonRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'jsonIdimageRate'),
          align: 'left',
          dataIndex: 'jsonIdimageRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idimageFaceRate'),
          align: 'left',
          dataIndex: 'idimageFaceRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'faceidNoRate'),
          align: 'left',
          dataIndex: 'faceidNoRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idNoBankcardRate'),
          align: 'left',
          dataIndex: 'idNoBankcardRate',
          width: 190,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'bankcardApplyRate'),
          align: 'left',
          dataIndex: 'bankcardApplyRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyAccessRate'),
          align: 'left',
          dataIndex: 'applyAccessRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'accessLoanRate'),
          align: 'left',
          dataIndex: 'accessLoanRate',
          width: 160,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regBankCardRate'),
          align: 'left',
          dataIndex: 'regBankCardRate',
          width: 280,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regApplyRate'),
          align: 'left',
          dataIndex: 'regApplyRate',
          width: 280,
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyLoanRate'),
          align: 'left',
          width: 280,
          dataIndex: 'applyLoanRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regLoanRate'),
          width: 260,
          align: 'left',
          dataIndex: 'regLoanRate',
        },
      ]
    },
    innerColumns() {
      return [
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'appVersion'),
          align: 'left',
          dataIndex: 'appVersion',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'installs'),
          align: 'left',
          dataIndex: 'installs',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regCount'),
          align: 'left',
          dataIndex: 'regCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'basicCount'),
          align: 'left',
          dataIndex: 'basicCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'linkmanCount'),
          align: 'left',
          dataIndex: 'linkmanCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'jsonCount'),
          align: 'left',
          dataIndex: 'jsonCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idimageCount'),
          align: 'left',
          dataIndex: 'idimageCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'faceCount'),
          align: 'left',
          dataIndex: 'faceCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idnoCount'),
          align: 'left',
          dataIndex: 'idnoCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'bankcardCount'),
          align: 'left',
          dataIndex: 'bankcardCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyCount'),
          align: 'left',
          dataIndex: 'applyCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'accessCount'),
          align: 'left',
          dataIndex: 'accessCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'loanCount'),
          align: 'left',
          dataIndex: 'loanCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'installsOptRate'),
          align: 'left',
          dataIndex: 'installsOptRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'optRegRate'),
          align: 'left',
          dataIndex: 'optRegRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regBasicRate'),
          align: 'left',
          dataIndex: 'regBasicRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'workLinkmanRate'),
          align: 'left',
          dataIndex: 'workLinkmanRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'linkedManJsonRate'),
          align: 'left',
          dataIndex: 'linkedManJsonRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'jsonIdimageRate'),
          align: 'left',
          dataIndex: 'jsonIdimageRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idimageFaceRate'),
          align: 'left',
          dataIndex: 'idimageFaceRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'faceidNoRate'),
          align: 'left',
          dataIndex: 'faceidNoRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idNoBankcardRate'),
          align: 'left',
          dataIndex: 'idNoBankcardRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'bankcardApplyRate'),
          align: 'left',
          dataIndex: 'bankcardApplyRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyAccessRate'),
          align: 'left',
          dataIndex: 'applyAccessRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'accessLoanRate'),
          align: 'left',
          dataIndex: 'accessLoanRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regBankCardRate'),
          align: 'left',
          dataIndex: 'regBankCardRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regApplyRate'),
          align: 'left',
          dataIndex: 'regApplyRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyLoanRate'),
          align: 'left',
          dataIndex: 'applyLoanRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regLoanRate'),
          align: 'left',
          dataIndex: 'regLoanRate',
        },
      ]
    },
  },
  created() {
    this.loadData(1)
    getApplist().then((res) => {
      this.appList = res.data || []
    })
  },
  methods: {
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams() // Query conditions
      getConvertData(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.ipagination.total = res.data.total
            this.dataSource = res.data.rows
          } else {
            this.ipagination.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    getQueryParams() {
      const { dataDt } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: dataDt && this.transformTime(dataDt[0]),
        endDate: dataDt && this.transformTime(dataDt[1]),
      }
      delete data.dataDt
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    handleTableChange(pagination, filters, sorter) {
      // TODO Filter
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    extpand(expanded, record) {
      // if(expanded){
      //   this.innerData = record.dataDetails;
      //
      //   console.log("------------->" + record);
      // } else {
      //   this.innerData = [];
      //   console.log("-------------> im close");
      // }
    },
    handleAdd() {
      this.$refs.modalForm.add()
      // this.$refs.modalForm.title = 'Add new'
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.appSsid = ''
      that.loadData(this.ipagination.current)
    },
    // modelCallback
    modalFormOk() {
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    getUrl() {
      var params = this.getQueryParams() // Query conditions
      var url =
        '/api/web/webpublic/statistics/convertDataExcel?startDate=' + params.startDate + '&endDate=' + params.endDate

      if (params.appssidList) {
        url += '&appssidList=' + params.appssidList
      }
      if (params.dataType) {
        url += '&dataType=' + params.dataType
      }
      return url
    },
    downLoadData() {
      const file = {
        fileUrl: this.getUrl(),
        fileName: 'convertDataExcel.xls',
      }
      this.loading = true
      exportFile(file)
        .catch((e) => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    downLoadData2(arg2) {
      var params = this.getQueryParams(arg2) // Query conditions
      const file = {
        fileUrl:
          '/api/web/webpublic/statistics/appAllCountExcel2?startDate=' +
          params.startDate +
          '&endDate=' +
          params.endDate +
          '&appssidList=' +
          params.appssidList,
        fileName: 'countLoanDataWithDateExcelColor.xls',
      }
      this.loading = true
      exportFile(file)
        .catch((e) => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    rowClassName(record, index) {
      const date = new Date(record.dataDt)
      let className = date.getDay() % 6 === 0 ? 'table_weekendColor' : ''
      return className
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';

.form-item {
  display: flex;
  align-items: center;
  gap: 8px;

  .form-label {
    text-align: right;
    white-space: nowrap;
    flex-shrink: 0;
  }

  :deep(.ant-picker) {
    flex: 1;
  }
}
</style>
